import { FC } from "react";
import { ActivityDateProps } from "./types";
import { Row } from "../../../containers";
import { Text } from "../../../typography";
import { useThemeStore } from "../../../../stores";
import { getDateStr, getTimeStr } from "../../../../utils";

const ActivityDate: FC<ActivityDateProps> = ({ children }) => {
  const theme = useThemeStore((state) => state.theme);
  return (
    <Row gap={5}>
      <Text size={10} color={theme.icon}>
        {getDateStr(children)}
      </Text>
      <Text size={10} color={theme.icon}>
        {getTimeStr(children)}
      </Text>
    </Row>
  );
};

export default ActivityDate;
